import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import * as convertKeys from 'convert-keys';
import { UpdateApiKeyPayload } from '../model/api-key-update.model';
import { BehaviorSubject } from 'rxjs';
import { ApiKey } from '../model/api-key.model';

@Injectable()
export class ApiKeysService {
  readonly apiKeys$: BehaviorSubject<ApiKey> = new BehaviorSubject<ApiKey>(null);

  constructor(private apiService: ApiService) {
    this.getKeys();
  }

  async getKeys(accountId?: string) {
    const url = accountId ? `api-keys?account_id=${accountId}` : 'api-keys';
    const response = await this.apiService.get(url);
    if (response) {
      const camelResponse = convertKeys.toCamel(response) as ApiKey;
      this.apiKeys$.next(camelResponse);
    }
  }

  async updateKey(keyId: string, payload: UpdateApiKeyPayload): Promise<ApiKey> {
    const response = await this.apiService.put(
      `api-keys/${keyId}`,
      payload
    );

    return convertKeys.toCamel(response);
  }
}
